import 'dayjs/locale/pt-br';
import domtoimage from 'dom-to-image';
import { inPlaceSort } from 'fast-sort';
import jsPDF from 'jspdf';
import { useEffect, useMemo, useState, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { BiWindow, BiWindows } from 'react-icons/bi';
import 'react-tabs/style/react-tabs.css';
import { DefaultButton } from '../../../components/Button/Button';
import PieceEdit from '../../../components/PieceEdit/PieceEdit';
import { OSBudgetTabs } from '../../../containers/OrderServiceBudget/TabsContainer/OSBudgetTabs';
import { BodyShopAddScreen } from '../../BudgetAdd/BodyShopAddScreen';
import BudgetAddAeServiceScreen from '../../BudgetAddAeService/BudgetAddAeServiceScreen';
import BudgetAddClient from '../../BudgetAddClient/BudgetAddClient';
import BudgetAddVehicle from '../../BudgetAddVehicle/BudgetAddVehicle';
import { HasEditedStatusProvider } from '../../ModalBudget/components/HasEditedContext';
import { getTotalSum } from '../../ModalBudget/utils/functions';
import PieceAddScreen from '../../PieceAdd/PieceAddScreen';
('pt-br');

const ModalBudget = ({
  values,
  closeModal,
  isNew,
  onChange,
  onSave,
  compareValues,
  onRemove,
  budget,
  showBudgetItems,
  open,
  setOpen,
  addBudget,
  client,
  clientLoading,
  vehicle,
  vehicleLoading,
  bodyshopService,
  setBodyshopService,
  setBodyshopServiceVersion,
  aeService,
  setAeService,
  part,
  setPart,
  parts,
  setParts,
  onRemovePiece,
  onRemoveService,
  onRemoveAeService,
  setReload,
  hvTable,
  setAddBudget,
  sendWhatsapp,
  setIsntLinearHour,
  isntLinearHour,
  serviceType,
  setServiceType,
  addedParts,
  addedServices,
  changeValue,
  changePartsValue,
  reloadPrint,
  company,
  isOpen,
  setIsOpen,
  openEditModal,
  onChangePiece,
  printCompany,
  deleteOptions,
  createOrigin,
  divCreatable,
  changeValueAeService,
  setValues,
  setSetHasCreatedConsultant,
  setReloadPrint,
  setOldValues,
  setHasCreated,
  setHasCreatedTypeOS,
  reloadConsultants,
  reloadTypeOS,
  setClientCreationContext,
  clientCreationContext,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentClientId, setCurrentClientId] = useState(0);
  const [currentVehicleId, setCurrentVehicleId] = useState(0);
  const timeoutsRef = useRef([]);

  // Cleanup de timeouts ao desmontar componente
  useEffect(() => {
    return () => {
      timeoutsRef.current.forEach(timeout => clearTimeout(timeout));
      timeoutsRef.current = [];
    };
  }, []);

  const totalSum = useMemo(
    () => getTotalSum(bodyshopService, parts, aeService),
    [bodyshopService, parts, aeService]
  );
  const totalBodyshopService = useMemo(
    () => getTotalSum(bodyshopService, [], []),
    [bodyshopService]
  );
  const totalParts = useMemo(() => getTotalSum([], parts, []), [parts]);
  const totalAeService = useMemo(
    () => getTotalSum([], [], aeService),
    [aeService]
  );

  const nodeInBlob = async () => {
    return new Promise((resolve, reject) => {
      // const printWindow = window.open("", "_blank");
      // printWindow.document.write(ref.current.outerHTML);
      // printWindow.focus();
      const timeout = setTimeout(() => {
        // const blob = new Blob([ref.current.outerHTML], {
        //   type: "application/pdf",
        // });
        var node = document.getElementById('my-node');
        domtoimage.toPng(node).then(function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          resolve(img);
        }).catch(reject);
      }, 2000);

      // Armazenar referência do timeout para cleanup
      timeoutsRef.current.push(timeout);
    });
  };

  const generatePdfBlob = async () => {
    const image = await nodeInBlob();

    return new Promise((resolve) => {
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: 'a4',
      });
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(image);
      const imgHeight =
        (imgProps.height * pdf.internal.pageSize.getWidth()) / imgProps.width;

      let yPosition = 0;

      while (yPosition < imgHeight) {
        if (yPosition > 0) {
          pdf.addPage();
        }
        pdf.addImage(
          image,
          'PNG',
          0,
          -yPosition,
          pdf.internal.pageSize.getWidth(),
          imgHeight
        );
        yPosition += pageHeight;
      }

      const pdfBlob = pdf.output('blob');
      resolve(pdfBlob);
    });
  };

  // Função para aguardar todas as imagens carregarem
  async function waitForImagesToLoad(element) {
    const images = element.querySelectorAll('img');
    const imagePromises = Array.from(images).map((img) => {
      if (img.complete && img.naturalHeight !== 0) {
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve; // Resolve mesmo com erro para não bloquear
        const timeout = setTimeout(resolve, 5000); // Timeout de segurança
        timeoutsRef.current.push(timeout);
      });
    });
    await Promise.all(imagePromises);
  }

  async function generatePDFFromRef(ref, filename) {
    if (!ref || !ref.current) {
      return null;
    }

    try {
      const element = ref.current;

      // Aguardar todas as imagens carregarem
      await waitForImagesToLoad(element);

      // Delay reduzido para manter contexto do usuário
      const delay = filename.includes('Laudo') ? 1000 : 800;
      await new Promise((resolve) => {
        const timeout = setTimeout(resolve, delay);
        timeoutsRef.current.push(timeout);
      });

      // Verificar dimensões
      if (element.offsetWidth === 0 || element.offsetHeight === 0) {
        throw new Error('Elemento com dimensões inválidas');
      }

      // Configuração otimizada
      const imgData = await domtoimage.toPng(element, {
        quality: 0.92,
        cacheBust: true,
        bgcolor: '#ffffff',
      });

      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [element.offsetWidth, element.offsetHeight],
      });

      pdf.addImage(
        imgData,
        'PNG',
        0,
        0,
        element.offsetWidth,
        element.offsetHeight
      );

      return pdf.output('blob');
    } catch (error) {
      console.error(`Erro ao gerar PDF de ${filename}:`, error);
      return null;
    }
  }

  async function generateAndSharePDF(
    printOSRef,
    printTermReportRef,
    options = {}
  ) {
    const { shareOS = true, shareLaudo = false } = options;

    try {
      const sanitizedClientName = (values?.client_name || 'Cliente').replace(
        /[\s\\/]/g,
        '_'
      );
      const sanitizedVehicleName = (values?.vehicle_name || 'Veiculo').replace(
        /[\s\\/]/g,
        '_'
      );

      // Gerar PDFs em paralelo para minimizar tempo
      const promises = [];

      if (shareOS && printOSRef) {
        const osFilename = `Ordem_de_Servico_${values.code}_${sanitizedClientName}_${sanitizedVehicleName}.pdf`;
        promises.push(
          generatePDFFromRef(printOSRef, osFilename).then((blob) =>
            blob ? { blob, filename: osFilename } : null
          )
        );
      }

      if (shareLaudo && printTermReportRef) {
        const laudoFilename = `Laudo_${values.code}_${sanitizedClientName}_${sanitizedVehicleName}.pdf`;
        promises.push(
          generatePDFFromRef(printTermReportRef, laudoFilename).then((blob) =>
            blob ? { blob, filename: laudoFilename } : null
          )
        );
      }

      // Aguardar todos os PDFs serem gerados
      const results = await Promise.all(promises);
      const files = results
        .filter((r) => r !== null)
        .map(
          (r) => new File([r.blob], r.filename, { type: 'application/pdf' })
        );

      if (files.length === 0) {
        alert(
          'Erro ao gerar os PDFs. Verifique se todas as imagens foram carregadas e tente novamente.'
        );
        return;
      }

      if (navigator.share) {
        // Verificar se o navegador suporta compartilhamento de arquivos
        if (navigator.canShare && !navigator.canShare({ files: files })) {
          alert('Seu navegador não suporta compartilhamento destes arquivos.');
          return;
        }

        // Chamar imediatamente sem await adicional para manter contexto do usuário
        return navigator.share({
          title: files.length === 1 ? files[0].name : 'Compartilhar Documentos',
          files: files,
        });
      } else {
        alert('Seu navegador não suporta compartilhamento de arquivos.');
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        // Usuário cancelou o compartilhamento
        return;
      } else {
        // Mensagem de erro mais específica
        if (error.name === 'NotAllowedError') {
          alert(
            'O compartilhamento precisa ser ativado por um clique direto. Por favor, tente novamente.'
          );
        } else {
          alert(`Erro ao compartilhar os documentos: ${error.message}`);
        }
      }
    }
  }

  const toShare = async (options = {}) => {
    try {
      setIsLoading(true);
      const { printOSRef, printTermReportRef, shareOS, shareLaudo } = options;
      await generateAndSharePDF(printOSRef, printTermReportRef, {
        shareOS,
        shareLaudo,
      });
    } catch (error) {
      console.error('Erro ao compartilhar:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const prosperaModal = document.querySelector('.prospera-modal');
    const modalContent = document.querySelector('.modal-content');
    const mainModal = document.querySelector('.main-content-modal1');
    const modalWrapper = document.querySelector('.modal-content-wrapper');
    // const textArea = document.querySelector('.text-observation-min');
    // const textArea1 = document.querySelector('.text-observation-min2');
    const serviceAdditionalArea = document.querySelector(
      '.service-additional-on'
    );
    const pieceGridtable = document.querySelector('.piece-gridtable');
    const serviceGridtable = document.querySelector('.service-gridtable');
    if (modalContent) {
      modalContent.style.backgroundColor = isFullscreen ? '#4b4b4d' : '#fff';
    }

    if (prosperaModal) {
      prosperaModal.classList.toggle('expanded', !isFullscreen);
      prosperaModal.classList.toggle('prospera-modal-fullscreen', isFullscreen);

      mainModal.classList.toggle('main-content-modal2', isFullscreen);
      modalWrapper.classList.toggle('modal-content-wrapper2', isFullscreen);
    }
    if (serviceAdditionalArea) {
      serviceAdditionalArea.classList.toggle(
        'service-additional-off',
        isFullscreen
      );
    }
    if (pieceGridtable) {
      pieceGridtable.classList.toggle('fullscreen-gridtable', isFullscreen);
    }
    if (serviceGridtable) {
      serviceGridtable.classList.toggle('fullscreen-gridtable', isFullscreen);
    }
  }, [isFullscreen]);

  useEffect(() => {
    const modal = document.querySelector('.modal');
    if (modal) {
      if (isLoading) {
        modal.classList.add('loading');
      } else {
        modal.classList.remove('loading');
      }
    }
  }, [isLoading]);

  inPlaceSort(bodyshopService).by('title');
  inPlaceSort(parts).by('part');

  return (
    <HasEditedStatusProvider>
      <div className={''}>
        {/* {`prospera-modal ${fullscreen ? 'prospera-modal-fullscreen' : 'prospera-modal-fullscreen'}`} */}
        <div className={'modal-container'}>
          <div className="modal-header">
            <div className="header-title">
              <h4 className="modal-title">
                {isNew
                  ? 'Adicionar Ordem de Serviço'
                  : 'Editar Ordem de Serviço'}
              </h4>
            </div>
            <div className="header-buttons">
              {compareValues ? (
                <DefaultButton
                  className="modal-footer-button"
                  label={isMobile ? '' : 'Salvar'}
                  icon={<AiOutlineCheck className="button-icon" />}
                  onClick={onSave}
                />
              ) : (
                <div />
              )}
              {isMobile ? (
                <div />
              ) : (
                <DefaultButton
                  className="modal-footer-button cancel"
                  onClick={() => {
                    setIsFullscreen(!isFullscreen);
                    showBudgetItems(1);
                  }}
                  icon={!isFullscreen ? <BiWindow /> : <BiWindows />}
                />
              )}
              <DefaultButton
                className="modal-footer-button cancel"
                label={isMobile ? '' : 'Cancelar'}
                icon={<AiOutlineClose className="button-icon-cancel" />}
                onClick={closeModal}
              />
            </div>
          </div>

          <OSBudgetTabs
            setHasCreatedTypeOS={setHasCreatedTypeOS}
            setHasCreated={setHasCreated}
            setOldValues={setOldValues}
            setReloadPrint={setReloadPrint}
            setSetHasCreatedConsultant={setSetHasCreatedConsultant}
            setValues={setValues}
            budget={budget}
            showBudgetItems={showBudgetItems}
            onChange={onChange}
            client={client}
            clientLoading={clientLoading}
            values={values}
            setOpen={setOpen}
            vehicle={vehicle}
            vehicleLoading={vehicleLoading}
            divCreatable={divCreatable}
            deleteOptions={deleteOptions}
            company={company}
            isFullscreen={isFullscreen}
            isntLinearHour={isntLinearHour}
            hvTable={hvTable}
            setIsntLinearHour={setIsntLinearHour}
            bodyshopService={bodyshopService}
            setBodyshopService={setBodyshopService}
            setBodyshopServiceVersion={setBodyshopServiceVersion}
            onRemoveService={onRemoveService}
            changeValue={changeValue}
            onRemovePiece={onRemovePiece}
            changePartsValue={changePartsValue}
            openEditModal={openEditModal}
            parts={parts}
            setParts={setParts}
            isOpen={isOpen}
            onRemoveAeService={onRemoveAeService}
            aeService={aeService}
            setAeService={setAeService}
            compareValues={compareValues}
            sendWhatsapp={sendWhatsapp}
            toShare={toShare}
            isLoading={isLoading}
            onRemove={onRemove}
            onSave={onSave}
            totalParts={totalParts}
            totalSum={totalSum}
            totalBodyshopService={totalBodyshopService}
            totalAeService={totalAeService}
            changeValueAeService={changeValueAeService}
            reloadPrint={reloadPrint}
            printCompany={printCompany}
            setCurrentClientId={setCurrentClientId}
            setCurrentVehicleId={setCurrentVehicleId}
            reloadConsultants={reloadConsultants}
            reloadTypeOS={reloadTypeOS}
            isNew={isNew}
            setClientCreationContext={setClientCreationContext}
          />
        </div>
      </div>

      <BodyShopAddScreen
        compareValues={compareValues}
        service={bodyshopService}
        addedServices={addedServices}
        serviceType={serviceType}
        setServiceType={setServiceType}
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        setAddBudget={setAddBudget}
        isOpen={open === 1}
        values={values}
        isntLinearHour={isntLinearHour}
        setValues={(newValues) => {
          const updatedValues = Array.isArray(newValues)
            ? newValues
            : [newValues];
          const filteredValues = updatedValues.filter(
            (value) => value && value.title
          );

          if (filteredValues.length > 0) {
            setBodyshopService((service) => [...service, ...filteredValues]);
            setBodyshopServiceVersion((v) => v + 1);
          }
        }}
        setOpen={setOpen}
      />
      <PieceAddScreen
        addedParts={addedParts}
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        isOpen={open === 2}
        partsArray={parts}
        setValues={(values) => setParts((part) => [...part, ...values])}
        setOpen={setOpen}
      />
      <BudgetAddClient
        key={`client-${currentClientId}-${open === 3 ? Date.now() : 'closed'}`}
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        isOpen={open === 3}
        setReload={setReload}
        setOpen={setOpen}
        createOrigin={createOrigin}
        values={values}
        currentClientId={currentClientId}
        clientCreationContext={clientCreationContext}
      />
      <BudgetAddVehicle
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        isOpen={open === 4}
        setOpen={setOpen}
        setReload={setReload}
        defaultValues={values}
        currentVehicleId={currentVehicleId}
      />

      <BudgetAddAeServiceScreen
        compareValues={compareValues}
        service={aeService}
        addedServices={addedServices}
        serviceType={serviceType}
        setServiceType={setServiceType}
        showBudgetItems={showBudgetItems}
        budget={addBudget}
        setAddBudget={setAddBudget}
        isOpen={open === 5}
        values={values}
        isntLinearHour={isntLinearHour}
        setValues={(newValues) => {
          const updatedValues = Array.isArray(newValues)
            ? newValues
            : [newValues];
          const filteredValues = updatedValues.filter(
            (value) => value && value.title
          );

          if (filteredValues.length > 0) {
            setAeService((service) => [...service, ...filteredValues]);
          }
        }}
        setOpen={setOpen}
      />

      <PieceEdit
        isOpen={isOpen}
        setOpen={setIsOpen}
        parts={parts}
        setParts={setParts}
        part={part}
        setPart={setPart}
        values={values}
        onChangePiece={onChangePiece}
      />
    </HasEditedStatusProvider>
  );
};

export default ModalBudget;
